import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-slate-950 px-4 py-5 text-center md:px-12" data-id="element-76" data-mp="3gfiugihumbe4">
      <p className="text-[11px] font-extrabold uppercase text-white" data-id="element-77" data-mp="32nulgo2wc31d">
        © 2026 Bright Digital Hub — All Rights Reserved.
      </p>
      <div className="mx-auto mt-1.5 max-w-[640px] space-y-1 text-[12px] leading-[1.4] text-white/70" data-id="element-78" data-mp="36qhgexuv642s">
        <p data-id="element-79" data-mp="3ug3fllb8kjas">
          Complete Postoperative Knee Rehabilitation System™ provides professional educational reference materials and
          practical resources for postoperative knee rehabilitation. It does not replace accredited professional training,
          individualized patient assessment, independent clinical judgment, the operating surgeon's instructions, current
          clinical guidelines, institutional protocols, or professional licensing requirements.
        </p>
        <p data-id="element-80" data-mp="2eyjs3rnvlax9">
          All clinical content must be independently reviewed and validated by qualified specialists before being
          distributed for clinical use.
        </p>
      </div>
      <nav aria-label="Legal" className="mt-1.5 text-[12px] text-white" data-id="element-81" data-mp="3gaz4da2vgxn9">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-82" data-mp="3v7zvbbd8ooko" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-83" data-mp="3v5n8okwjdq1a">•</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-amber-400" data-id="element-84" data-mp="3q7lqs3aujwre">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-85" data-mp="34pa1a0t5yjb">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline transition-colors duration-150 hover:text-amber-400" data-id="element-86" data-mp="hsttig7oqe35">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}